import styled, { keyframes } from 'styled-components';

export enum SpinnerSize {
  huge = 'spinner--huge',
  large = 'spinner--large',
  regular = 'spinner--regular',
  small = 'spinner--small',
  tiny = 'spinner--tiny',
}

export interface ISpinner {
  /** Spinner visual size. */
  size?: SpinnerSize;
}

const spinningKeyframes = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

/**
 * Spinner is CSS animated element that should be shown during network activity.
 */
export const Spinner = styled.div<ISpinner>`
  animation-name: ${spinningKeyframes};
  animation-duration: 1200ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: 50%;
  border: ${(props) => (props.size === SpinnerSize.regular ? `4px` : `2px`)} solid
    ${(props) => props.theme.colors.primary};
  border-left-color: transparent;
  height: ${(props) =>
    props.size === SpinnerSize.regular ? `32px` : props.size === SpinnerSize.tiny ? `8px` : `16px`};
  width: ${(props) => (props.size === SpinnerSize.regular ? `32px` : props.size === SpinnerSize.tiny ? `8px` : `16px`)};
  z-index: 1;
`;
